import {  Component, Vue ,Watch} from "vue-property-decorator"
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'
import {getDeparmentList, getMarketCooperationVisitList, getMarketCooperationVisitListDataExport} from "@/api/common";
import {UserModule} from "@/store/modules/user";
import {menuBtn} from "@/utils/menu_level2_button";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
  components:{
    MoreUsersFilter
  }
})
export default class OrderStatisticsData extends Vue {
  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  souCourseName = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  tableHeader: any = [
    { filds: 'marketCooperationName', cnFilds: '合作伙伴名称', isShow: true, id: 1 },
    { filds: 'userRealName', cnFilds: '拜访人', isShow: true, id: 2 },
    { filds: 'userDepartmentName', cnFilds: '拜访人所属部门', isShow: true, id: 3 },
    { filds: 'address', cnFilds: '拜访地点', isShow: true, id: 4 },
    { filds: 'visitAt', cnFilds: '拜访时间', isShow: true, id: 5 },
    { filds: 'content', cnFilds: '拜访主要内容', isShow: true, id: 6 },
    { filds: 'price', cnFilds: '花费金额', isShow: true, id: 7 },
  ]
  marketCooperationName = ''
  visitAt: Date[] | null = null
  price = ''
  userIdList = []  //拜访人
  filter_price = ''
  filter_amount = ''
  deparmentList: any = [] // 部门列表
  checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
  accessibleList: any = []
  checkDeparmentInfo: any = [] // 选中的部门信息
  departmentIdList = []
  timer = null
  // isReadonly = false


  created() {
    this.getTableData()
    this.getDeparment()
  }

  get arrfilter_price() {
    const filter_price = this.filter_price
    const filter_amount = this.filter_amount
    return {
      filter_price, filter_amount
    }
  }

  async getDeparment() {
    const data: any = await getDeparmentList()
    this.deparmentList = data
  }
  chooseDepartment(checkedKeys,checkedData){

    // 取消勾选
    const [accessibleList,getCheckedKeys] = [this.accessibleList,(this.$refs.tree as HTMLFormElement).getCheckedKeys()];
    // 循环删除this.accessibleList中的项
    for(const i in accessibleList){
      if(accessibleList[i].id == checkedKeys.id){
        this.accessibleList.splice(i,1);
        return;
      }
    }
    // 添加勾选
    const [arr,newArr] = [[],(this.$refs.tree as HTMLFormElement).getCheckedKeys()];
    arr.push(checkedKeys);
    function dealData(arr,newArr){
      for(const i in arr){
        newArr.push(arr[i].id);
        dealData(arr[i].children,newArr);
      }
    }
    // newArr代表获取出来的当前节点以及其下的所有子节点的id
    dealData(arr,newArr);
    (this.$refs.tree as HTMLFormElement).setCheckedKeys(newArr);
    // newJsonArr代表所有选中的节点
    const newJsonArr = (this.$refs.tree as HTMLFormElement).getCheckedNodes();
    this.accessibleList = newJsonArr;
    this.checkDeparmentInfo = []

    newJsonArr.map(item => {
      this.checkDeparmentInfo.push({
        department: {
          name: item.name,
          detail: null,
          id: item.id
        },
        departmentId: item.id
      })
    })

  }

  treeChange(item: any, itembol: boolean) {
    if(itembol) {
      const res = (this.$refs.tree as HTMLFormElement).getCheckedNodes()
      const arrDeptId = []
      res.forEach((item) => {
        arrDeptId.push({
          department: {
            name: item.name,
            detail: null,
            id: item.id
          },
          departmentId: item.id
        })
      })
      this.checkDeparmentInfo = arrDeptId
    } else {

      this.checkDeparmentInfo.map((t: any, i: number) => {
        if(t.departmentId === item.id){
          this.checkDeparmentInfo.splice(i, 1)
        }
      });
    }

    this.checkRangeDepartmentList = []
    this.checkDeparmentInfo.forEach((item) => {
      this.checkRangeDepartmentList.push(item.departmentId)
    })
    this.departmentIdList = this.checkRangeDepartmentList

  }

  async getTableData() {
    this.tableLoading = true

    this.price = this.filter_price + this.filter_amount
    const { allNum, marketCooperationVisitList } = await getMarketCooperationVisitList(delNullProperty({
      limit: this.limit,
      page: this.page,
      userIdList : this.userIdList,
      marketCooperationName : this.marketCooperationName,
      visitAt : this.changeTime(this.visitAt as Date[]),
      price : this.price,
      departmentIdList: this.departmentIdList
    })) as unknown as { allNum: number; marketCooperationVisitList: any[] }
    this.tableData = marketCooperationVisitList
    this.total = allNum
    this.tableLoading = false
    // this.isReadonly = false
  }

// 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
    })
    time = time.slice(0, time.length - 1)
    return time
  }


  async exportExcel(keys: string = '') {
    this.exportButtonDisabled = true
    await getMarketCooperationVisitListDataExport(
        delNullProperty(
            {
              userIdList: this.userIdList,
              marketCooperationName: this.marketCooperationName,
              visitAt: this.changeTime(this.visitAt as Date[]),
              price: this.price,
              departmentIdList:this.departmentIdList,
              keys,
            })
    )
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    this.exportButtonDisabled = false
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }
  /*
     按钮权限验证
     */
  handleBtn(id: number) {
    return menuBtn(id)
  }

  changeuserIdList(e){
    this.userIdList = e.id
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = 1
      this.getTableData()
    }, 1000)
  }

  @Watch('arrfilter_price')
  handlearrfilter_price(nVal, oVal) {
    if ((nVal.filter_price && nVal.filter_amount) ||(!nVal.filter_price && !nVal.filter_amount)){
      this.pageChange(1)
    }
  }
}
